import {Component, Input} from '@angular/core';
import {FilterModelDto} from "../../../../models/filter.model";

@Component({
  selector: 'app-terminal-page-filter',
  templateUrl: './terminal-page-filter.component.html',
  styleUrls: ['./terminal-page-filter.component.scss']
})
export class TerminalPageFilterComponent {
  @Input() filterStatuses: FilterModelDto[] | undefined
  @Input() filterBanks: FilterModelDto[] | undefined
}
